export default __webpack_public_path__ + "static/media/tempestofsethead.23722466.png";